<div id="status-mobile">

  <div>
    <kl-status-logs [usersList]="dialogData?.data?.users"></kl-status-logs>
  </div>

</div>
